import React from 'react'
import { useAuth } from '../contexts/AuthContext'

const DebugAuth = () => {
  const { user, profile, isAdmin, isOwner, canViewHidden } = useAuth()

  return (
    <div className="min-h-screen bg-white pt-40 px-4">
      <div className="max-w-2xl mx-auto">
        <h1 className="text-3xl font-bold mb-8">Auth Debug Info</h1>
        
        <div className="space-y-6">
          <div className="border p-4 rounded">
            <h2 className="text-xl font-semibold mb-2">User</h2>
            <pre className="bg-gray-100 p-3 rounded overflow-auto">
              {JSON.stringify(user, null, 2)}
            </pre>
          </div>

          <div className="border p-4 rounded">
            <h2 className="text-xl font-semibold mb-2">Profile</h2>
            <pre className="bg-gray-100 p-3 rounded overflow-auto">
              {JSON.stringify(profile, null, 2)}
            </pre>
          </div>

          <div className="border p-4 rounded">
            <h2 className="text-xl font-semibold mb-2">Computed Values</h2>
            <div className="space-y-2">
              <p><strong>isAdmin:</strong> {String(isAdmin)}</p>
              <p><strong>isOwner:</strong> {String(isOwner)}</p>
              <p><strong>canViewHidden:</strong> {String(canViewHidden)}</p>
            </div>
          </div>

          <div className="border p-4 rounded">
            <h2 className="text-xl font-semibold mb-2">Token</h2>
            <pre className="bg-gray-100 p-3 rounded overflow-auto text-xs break-all">
              {localStorage.getItem('auth_token') || 'No token'}
            </pre>
          </div>

          <div className="border p-4 rounded bg-yellow-50">
            <h2 className="text-xl font-semibold mb-2">Instructions</h2>
            <ol className="list-decimal list-inside space-y-2">
              <li>Check if <code>profile.role</code> is present</li>
              <li>If role is missing, you need to logout and login again</li>
              <li>Make sure the SQL migration was applied to add the role column</li>
              <li>After setting role in database, user must re-login to get new token</li>
            </ol>
          </div>
        </div>
      </div>
    </div>
  )
}

export default DebugAuth
